import { PolicyChargeTypeChartData } from 'store/modules/Charts/types';

export const findMaxCharge = (
  existingPoliciesCharges: Array<PolicyChargeTypeChartData>,
  recommendedPoliciesCharges: Array<PolicyChargeTypeChartData>
) => {
  const policiesCharges = [
    ...existingPoliciesCharges,
    ...recommendedPoliciesCharges
  ];

  const maxValue = [...policiesCharges].sort((a: any, b: any) => {
    return b.percentage_value - a.percentage_value;
  });

  if (maxValue.length > 0) {
    return Math.ceil(maxValue[0].percentage_value * 100);
  } else {
    return 3;
  }
};
